'use es6';

import get from 'transmute/get';
export const getId = get('id');
export const getParentTeamId = get('parentTeamId');
export const getChildTeams = get('childTeams');
export const getUserIds = get('userIds');
export const getSecondaryUserIds = get('secondaryUserIds');
export const getName = get('name');